'use strict';

angular.module('licensure.services')
    .factory('IPDeficiencyCategories', ['$http', '$q', function ($http, $q) {

        return {
            get: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/IPDeficiencyCategories', {
                        params: {
                        
                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getByID: function (id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + '/api/IPDeficiencyCategories/' + id, {
                        params: {

                        }
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            save: function (deficiency_category) {
                var d = $q.defer();

                var method = 'POST';
                var url = apiLocation + '/api/IPDeficiencyCategories/';
                if (!isUndefined(deficiency_category.id)) {
                    method = 'PUT'
                    url += deficiency_category.id
                }

                $http({
                    method: method,
                    url: url,
                    data: {
                        deficiency_category: deficiency_category
                    }
                }).then(function (response) {
                    d.resolve(response.data);
                }).catch(function (response) {
                    // handle error
                });

                return d.promise;
            }
        };
    }])
;